<template>
  <div class="ring-item">
    <div class="ring-item-warp">
      <el-progress type="dashboard" :percentage="percentage" :stroke-width="strokeWidth" :color="colors" :text-inside="true" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'RingItem',
  props: {
    percentage: {
      type: Number,
      default: 0
    },
    strokeWidth: {
      type: Number,
      default: 4
    },
    color: {
      type: String,
      default: '#fff'
    }
  },
  data() {
    return {
      colors: [
        { color: this.color, percentage: 100 }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
  .ring-item{
    width: 100%;
    height: 100%;
    position: relative;
    .ring-item-warp{
      width: 100%;
      height: 100%;
      position: relative;
      transform: rotate(135deg);
    }
    /deep/ .el-progress{
      width: 100%!important;
      height: 100%!important;
    }
    /deep/ .el-progress-circle{
      width: 100%!important;
      height: 100%!important;
    }
    /deep/ svg path{
      &:hover{
        stroke-width: 6;
      }
    }
    /deep/ svg path:nth-child(1){
      stroke: rgba(255, 252, 253, 0.1);
    }
  }
</style>
